// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes slidy {
  0% { left: 0%; }
  5% { left: 0%; }
  10% { left: 0%; }
  20% { left: -100%; }
  25% { left: -100%; }
  30% { left: -100%; }
  40% { left: -200%; }
  45% { left: -200%; }
  50% { left: -200%; }
  60% { left: -300%; }
  65% { left: -300%; }
  70% { left: -300%; }
  80% { left: -400%; }
  85% { left: -400%; }
  90% { left: -400%; }
  100% { left: 0%; }
}

.outr h1{
  display: none;
}

.outr{
  position: relative;
  display: block;
  align-items: center;
  justify-content: center;
  background: rgb(255, 255, 255, 0.1);
}

#slider { 
  align-self: center;
  justify-self: center;
  overflow: hidden;
  margin-top: 10px;
  height: -moz-fit-content;
  height: fit-content;
  width: 51%;
}

#slider img { width: 20%; float: left; }
#slider figure { 
  position: relative;
  width: 500%;
  margin: 0;
  left: 10;
  text-align: left;
  font-size: 0;
  animation: 14s slidy infinite; 
}

@media (max-width:998px){
  .outr{
    position: relative;
  }

  .outr h1{
    position: relative;
    display: flex;
    text-align: center;
    margin-left: 12.5vw;
    margin-top: 40%;
    margin-bottom: 6rem;
    display: flex;
    font-size: 8.5vw;
  }

  #slider{
    width: 90%;
    height: 100vh;
    left: 5%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/About/Certifications/Certifications.css"],"names":[],"mappings":"AAAA;EACE,KAAK,QAAQ,EAAE;EACf,KAAK,QAAQ,EAAE;EACf,MAAM,QAAQ,EAAE;EAChB,MAAM,WAAW,EAAE;EACnB,MAAM,WAAW,EAAE;EACnB,MAAM,WAAW,EAAE;EACnB,MAAM,WAAW,EAAE;EACnB,MAAM,WAAW,EAAE;EACnB,MAAM,WAAW,EAAE;EACnB,MAAM,WAAW,EAAE;EACnB,MAAM,WAAW,EAAE;EACnB,MAAM,WAAW,EAAE;EACnB,MAAM,WAAW,EAAE;EACnB,MAAM,WAAW,EAAE;EACnB,MAAM,WAAW,EAAE;EACnB,OAAO,QAAQ,EAAE;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAmB;EAAnB,mBAAmB;EACnB,UAAU;AACZ;;AAEA,cAAc,UAAU,EAAE,WAAW,EAAE;AACvC;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,QAAQ;EACV;AACF","sourcesContent":["@keyframes slidy {\n  0% { left: 0%; }\n  5% { left: 0%; }\n  10% { left: 0%; }\n  20% { left: -100%; }\n  25% { left: -100%; }\n  30% { left: -100%; }\n  40% { left: -200%; }\n  45% { left: -200%; }\n  50% { left: -200%; }\n  60% { left: -300%; }\n  65% { left: -300%; }\n  70% { left: -300%; }\n  80% { left: -400%; }\n  85% { left: -400%; }\n  90% { left: -400%; }\n  100% { left: 0%; }\n}\n\n.outr h1{\n  display: none;\n}\n\n.outr{\n  position: relative;\n  display: block;\n  align-items: center;\n  justify-content: center;\n  background: rgb(255, 255, 255, 0.1);\n}\n\n#slider { \n  align-self: center;\n  justify-self: center;\n  overflow: hidden;\n  margin-top: 10px;\n  height: fit-content;\n  width: 51%;\n}\n\n#slider img { width: 20%; float: left; }\n#slider figure { \n  position: relative;\n  width: 500%;\n  margin: 0;\n  left: 10;\n  text-align: left;\n  font-size: 0;\n  animation: 14s slidy infinite; \n}\n\n@media (max-width:998px){\n  .outr{\n    position: relative;\n  }\n\n  .outr h1{\n    position: relative;\n    display: flex;\n    text-align: center;\n    margin-left: 12.5vw;\n    margin-top: 40%;\n    margin-bottom: 6rem;\n    display: flex;\n    font-size: 8.5vw;\n  }\n\n  #slider{\n    width: 90%;\n    height: 100vh;\n    left: 5%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
